import React, { FunctionComponent, useState, useRef, ReactElement } from 'react';
import { ExpandingArea, ExpandingAreaProps } from './index';
import { FormattedMessage } from 'react-intl';
import scrollIntoView from 'scroll-into-view';
import { ReadMoreButton } from './ReadMoreButton';

import styles from './ExpandingAreaWithReadMore.scss';

type ExpandingAreaWithReadMoreProps = Omit<ExpandingAreaProps, 'expanded'> & {
    readMore?: ReactElement;
    readLess?: ReactElement;
    buttonClass?: string;
    showArrow?: boolean;
};

const readMoreMessage = (
    <FormattedMessage id="expandingArea.continueReading" defaultMessage="Continue reading" />
);
const readLessMessage = <FormattedMessage id="expandingArea.readLess" defaultMessage="Read less" />;

export const ExpandingAreaWithReadMore: FunctionComponent<ExpandingAreaWithReadMoreProps> = ({
    readMore = readMoreMessage,
    readLess = readLessMessage,
    wrapperClass,
    buttonClass,
    showArrow = true,
    ...props
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isContentExpandable, setIsContentExpandable] = useState(false);
    const contentRef = useRef(null);

    return (
        <div className={wrapperClass} ref={contentRef}>
            <ExpandingArea
                {...props}
                wrapperClass={styles.expandingAreaWrapper}
                expanded={isExpanded}
                setIsContentExpandable={setIsContentExpandable}
            />

            {isContentExpandable && (
                <ReadMoreButton
                    isExpanded={isExpanded}
                    className={buttonClass}
                    showArrow={showArrow}
                    onClick={() => {
                        if (isExpanded && contentRef && contentRef.current) {
                            scrollIntoView(contentRef.current, { time: 200 });
                        }
                        setIsExpanded(!isExpanded);
                    }}
                    readLessMessage={readLess}
                    readMoreMessage={readMore}
                />
            )}
        </div>
    );
};
